import { Box, Button, Typography } from '@mui/material'
import { useCallback } from 'react'

export const NotAuthorizedPage = () => {
  const redirectToLoginPage = useCallback(() => {
    const returnUrl = window.location.href
    location.href = `${phoenix.runtimeConfig.SERVER_URL}/deployments/${phoenix.runtimeConfig.DEPLOYMENT_ID}/auth?returnUrl=${encodeURIComponent(returnUrl)}`
  }, [])

  return (
    <>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 4,
        }}
      >
        <Typography variant="h4">Salsita Admin Panel</Typography>
        <Typography variant="body1">This is a private area. Please log in to continue.</Typography>

        <Button variant="contained" onClick={redirectToLoginPage}>
          Log In
        </Button>
      </Box>
    </>
  )
}
